'use strict';
rcElementRangeGrid.$inject = ['$q', 'accountService', 'accountStructureService'];
angular.module('schoolLinqApp').directive('rcElementRangeGrid', rcElementRangeGrid);

function rcElementRangeGrid($q, accountService, accountStructureService) {
	return {
		require: ['ngModel'],
		scope: {
			ngModel: '=',
			fundOnly: '=',
			initValues: '=',
		},
		replace: true,
		restrict: 'AE',
		template: require('@ajs/templates/reports/rcElementRangeGrid.html'),
		controller: [
			'$scope',
			function ($scope) {
				$scope.loadingElementRangeGrid = $q.all([loadAccountStructures()]);

				function loadAccountStructures() {
					if (!$scope.ngModel) return accountStructureService.getStructureWithGrantYear().then(finishLoadingAccountStructures);

					function finishLoadingAccountStructures(response) {
						if (!$scope.ngModel) $scope.ngModel = [];

						let accountStructure = response.data.accountStructure;

						if (accountStructure.UnifiedElementMap) {
							if ($scope.fundOnly) {
								// get the Fund name (just get it from the Asset Element Map since it will be the same for all the types)
								let fundElement = accountStructure.AssetElementMap.split('.')[accountStructure.AssetElementFundIndex];
								let masks = accountStructure.AssetAccountMask.split('.');
								let fundMask = masks[accountStructure.AssetElementFundIndex];

								let startIdx = 1;
								for (let mIdx = 0; mIdx < parseInt(accountStructure.AssetElementFundIndex); mIdx++) {
									startIdx += masks[mIdx].length;
								}

								$scope.ngModel.push({
									element: fundElement,
									maxLength: fundMask.length,
									maxValue: fundMask.replace(/0/g, '9'),
									fromValue: $scope.initValues ? fundMask : null,
									toValue: $scope.initValues ? fundMask.replace(/0/g, '9') : null,
									accountTypeId: 0,
									startIndex: startIdx,
								});
							} else {
								// build list for elements
								var elements = accountStructure.UnifiedElementMap.split('.');
								var masks = accountStructure.UnifiedAccountMask.split('.');

								var i = 0;
								for (i = 0; i < elements.length; i++) {
									let startIdx = 1;
									for (let mIdx = 0; mIdx < i; mIdx++) {
										startIdx += masks[mIdx].length;
									}

									$scope.ngModel.push({
										element: elements[i].toString(),
										maxLength: masks[i].length,
										maxValue: masks[i].replace(/0/g, '9'),
										fromValue: $scope.initValues ? masks[i] : null,
										toValue: $scope.initValues ? masks[i].replace(/0/g, '9') : null,
										accountTypeId: 0,
										startIndex: startIdx,
									});
								}
							}
						}

						return angular.noop;
					}
				}

				$scope.fixElementToValue = function (index) {
					var acctF = $scope.ngModel[index];
					if (acctF) {
						if (!acctF.toValue || parseInt(acctF.fromValue) > parseInt(acctF.toValue)) {
							acctF.toValue = acctF.maxValue;
						}
					}
				};

				$scope.clearAll = function () {
					for (var idx = 0; idx < $scope.ngModel.length; idx++) {
						var acctF = $scope.ngModel[idx];
						acctF.fromValue = null;
						acctF.toValue = null;
					}
				};
			},
		],
	};
}
